  <header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/tsc.png" alt="" height="22" style="height: 54px;margin-top: 9px;margin-left: -15px;">
          </span>
          <span class="logo-lg">
            <img src="assets/images/tsc.png" alt="" height="17"style="margin-top: 10px;" >
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/tsc.png" alt="" height="22" style="height: 54px;margin-top: 9px;margin-left: -15px;">
          </span>
          <span class="logo-lg">
            <img src="assets/images/tsc.png" alt="" height="60" style="margin-top: 10px;">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" [ngClass]="{ 'd-none': theme === 'horizontal' }" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
          <span class="bx bx-search-alt"></span>
        </div>
      </form>      
    </div>

    <div class="d-flex">
      <!-- <div class="dropdown d-inline-block d-lg-none ms-2" dropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown" aria-haspopup="true" dropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" *dropdownMenu aria-labelledby="page-header-search-dropdown">
          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div> -->

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <ejs-dialog *ngIf="notificationsEnabled" id="component-dialog" #Dialog [visible]="false" [showCloseIcon]='true' width="400px" [position]="position">
        <ng-template #content>
          <app-notification (NotificationCountChanged)="refreshCount()"></app-notification>
        </ng-template>
      </ejs-dialog>

      <div class="d-inline-block" *ngIf="notificationsEnabled">
        <button type="button" class="btn header-item noti-icon" (click)="openDialog()">
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge bg-danger rounded-pill">{{unReadCount}}</span>
        </button>
      </div>

      <div class="py-3">
        <ejs-splitbutton [items]='items' content="{{user.firstName}} {{user.lastName}}" (select)="profileList($event)" cssClass="e-flat"></ejs-splitbutton>
      </div>
    </div>
  </div>
  <app-top-ticker [messages]="messages"></app-top-ticker>
</header>
